var AutoComplete;
(function (AutoComplete) {
    var Controller = (function () {
        function Controller() {
            $(document).on('focus', '.autocomplete input:not([disabled="disabled"]):not([readonly="readonly"])', function () {
                if (this.value.length > 1) {
                    var resultsid = 'autocompleteResults_' + this.id;
                    $('#' + resultsid).removeClass('inactive').addClass('active');
                }
            }).on('blur', '.autocomplete input', function () {
                if (this.value.length > 1) {
                    var resultsid = 'autocompleteResults_' + this.id;
                    $('#' + resultsid).addClass('inactive').removeClass('active');
                }
            }).on('input', '.autocomplete input', function () {
                var results = $('#autocompleteResults_' + this.id);
                if (this.value.length > 1 && results.children().length > 0) {
                    results.removeClass('inactive').addClass('active');
                } else {
                    results.addClass('inactive').removeClass('active');
                }
            }).on('keydown', '.autocomplete input', function (event) {
                if (this.value.length > 1) {
                    var resultsid = 'autocompleteResults_' + this.id;
                    var obj = $('#' + resultsid);
                    var active = obj.find('.active');
                    var hasActive = active.length === 1;

                    switch (event.keyCode) {
                        case 40: // down
                            event.preventDefault();
                            if (!hasActive) {
                                obj.children().first().addClass('active');
                            } else if (hasActive && active.next().length === 1) {
                                active.next().addClass('active');
                                active.removeClass('active');
                            }

                            break;
                        case 38: // up
                            event.preventDefault();
                            if (hasActive) {
                                if (active.prev().length === 1) {
                                    active.prev().addClass('active');
                                }
                                active.removeClass('active');
                            }

                            break;
                        case 13: // enter
                        case 9 : // tab
                            if (hasActive) {
                                event.preventDefault();
                                $(active).trigger('mousedown');
                            }
                            this.blur();

                            break;
                    }
                }
            });
        }

        return Controller;
    })();
    AutoComplete.Controller = Controller;
})(AutoComplete || (AutoComplete = {}));
var AutoComplete = new AutoComplete.Controller();